import {
  Accordion as RadixAccordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  AccordionHeader,
} from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";
import type {
  AccordionSingleProps,
  AccordionMultipleProps,
} from "@radix-ui/react-accordion";

type IAccordionProps = {
  items: {
    label: React.ReactNode;
    content: React.ReactNode;
    suffix?: React.ReactNode;
  }[];
  expanded?: boolean;
  /** When false, header is non-interactive with no chevron or suffix. Defaults to true. */
  collapsible?: boolean;
} & (AccordionSingleProps | AccordionMultipleProps);

const SharedAccordion = ({
  items,
  expanded = false,
  collapsible = true,
  ...props
}: IAccordionProps) => {
  const defaultValue: any = expanded
    ? items.map((_, i) => `item-${i}`)
    : undefined;

  return (
    <RadixAccordion defaultValue={defaultValue} {...props}>
      {items.map((item, index) => (
        <AccordionItem
          className="AccordionItem not-last:border-b border-border pb-4 not-last:mb-4"
          value={`item-${index}`}
          key={`item-${index}`}
        >
          <AccordionHeader className="AccordionHeader">
            {collapsible ? (
              <AccordionTrigger className="flex items-center justify-between w-full group text-sm font-semibold">
                {item.label}
                <div className="flex items-center gap-2">
                  {item.suffix}
                  <ChevronDownIcon className="w-4 h-4 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180" />
                </div>
              </AccordionTrigger>
            ) : (
              <div className="flex items-center justify-between w-full text-sm font-semibold py-1">
                {item.label}
              </div>
            )}
          </AccordionHeader>
          <AccordionContent className="pt-2">{item.content}</AccordionContent>
        </AccordionItem>
      ))}
    </RadixAccordion>
  );
};

export { SharedAccordion };
